<template>
  <!-- danger -->
  <div
    class="tw-content tw-view-text"
    :class="{ 'tw-whitespace-pre-line': !content.includes('<p>') }"
    v-html="
      Settings.allowLinks ? addBlankTargets(content) : stripLinks(content)
    "
  />
</template>

<script>
import { stripLinks, addBlankTargets } from '@helpers/formatContent.js'
import { watchEffect, nextTick } from 'vue'
import hljs from 'highlight.js/lib/common'
import { Settings } from '@config/game.js'
import { watch } from 'vue'
hljs.configure({ ignoreUnescapedHTML: true })

export default {
  props: {
    content: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    watchEffect(() => {
      if (props.content) {
        // Run on next tick after DOM has finished rendering
        nextTick(hljs.highlightAll)
      }
    })
    watch(
      () => Settings.value.allowLinks,
      () => {
        nextTick(hljs.highlightAll)
      }
    )

    return {
      addBlankTargets,
      stripLinks,
      Settings,
    }
  },
}
</script>

<style>
@import url('/public/css/github-dark-dimmed.css');
</style>
